import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";

import {GET_FACILITIES,GET_FACILITY,UPDATE_FACILITY,GET_FACILITY_INFO} from "./actions.type";



const FacilityModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    facilityStatuesFilter: []
  },
  mutations:{
    SET_FACILITY_STATUS_FILTER(state,statues){
      state.facilityStatuesFilter = statues;
    },
  },
  getters: {
    getFacilityStatusFilter(state){
      return state.facilityStatuesFilter;
    }
  },
  actions: {
    SET_UNIQUE_STATUS(context,payload){
      context.commit('SET_FACILITY_STATUS_FILTER',payload.uniqueStatuses);
    },
    async [GET_FACILITIES](context,payload) {
        let res = {};
        let url = "/facilities";
        await ApiService.get(url)
          .then(response => {
            let items = response.data.data;
            res = items;
          })
          .catch(error => {
            res = error;
          })
      return res;
    },
    [GET_FACILITY](context,payload){
      return new Promise((resolve,reject) => {
        ApiService.get("/facilities/"+payload.facility_id)
          .then(({data}) => {
            resolve(data);
          })
          .catch(({response}) => {
            reject(response);
          })
      });
    },
    [UPDATE_FACILITY](context,payload){
      let params = payload.data.params;

      let contacts = [];
      let contactObj = {};
      contactObj.name = params.contact_name;
      contactObj.phone = params.contact_phone;
      contacts.push(contactObj);

      return new Promise((resolve,reject) => {
        ApiService.put('/facilities/'+payload.data.facility_id,{
          billing_email:params.billing_email,
          address:params.address,
          contacts:{'contacts':contacts},
          state:params.state,
          suburb:params.suburb,
        }).then(({data}) => {
          resolve(data);
        })
        .catch(({response}) => {
          reject(response.data);
        });
      });
    },
    async [GET_FACILITY_INFO](context,payload){
      let res = {};
      const zeroPad = (num, places) => String(num).padStart(places, '0');
      await ApiService.get('/facilities/getInfo/' + zeroPad(''+payload, 6))
        .then(response => {
          let facility_info = response.data.data[0];
          res = facility_info;
        }).catch(error => {
          res = error;
        });
      return res;
    }
  }
};
export default FacilityModule;
